import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function DOBValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        const enteredDate = new Date(value);

        // Check if the value is a valid date
        if (isNaN(enteredDate.getTime())) {
            return { invalidDate: true };
        }

        // Check if the date is in the future
        const today = new Date();
        if (enteredDate >= today) {
            return { dateInFuture: true };
        }

        return null;
    };
}
